// removed by extract-text-webpack-plugin
module.exports = {"fixedHeaderGrid":"XQYab"};


//////////////////
// WEBPACK FOOTER
// ./admin/permissions/components/FixedHeaderGrid.css
// module id = 2059
// module chunks = 3